import validator from 'validator';

/**
 * Usage:
 *  const usernameValidator = create((value, {isEmpty, trim}) => !isEmpty(trim(username)));
 *  const isValidName = usernameValidator('test'); // -> true
 */
export function create(f) {
  return value => f(value, validator);
}

/**
 * Usage:
 *  const notEmpty = create(value => value.length > 0);
 *  const maxLength = create(value => value.length < 100);
 *  const rule = merge(notEmpty, maxLength);
 */
export function merge(...validators) {
  return value => validators.every(f => f(value));
}

/**
 * Usage:
 *  const usernameValidator = create((value, {isEmpty, trim}) => !isEmpty(trim(username)));
 *  const personValidator = validate({
 *    username: usernameValidator
 *  });
 *  const isValid = personValidator({username: 'test'}); // -> true
 */
export function validate(rules) {
  return obj => Object.keys(rules).every(key => rules[key](obj[key]));
}
